import { createPlateEditor } from 'platejs/react';
import { docxFileToFragment } from './docxToPlate';
import { sanitizePlateFragment } from './sanitizePlateFragment';
import { createPlateEditorPlugins } from '../hooks/usePlateEditorLogic';
import { EMPTY_EDITOR_VALUE } from '../types/types';

/**
 * Convert a `.docx` File/Blob straight into a sanitized Plate value, ready to
 * save or render read-only. Mirrors ReportEditorRoute's import path
 * (:166-180): a headless editor built with the production plugin config feeds
 * `docxFileToFragment` so deserialization lands the same node types (headings,
 * lists, tables, links, images) the live editor would produce.
 */
export async function docxBlobToPlateValue(file: File | Blob): Promise<any[]> {
    const headlessEditor = createPlateEditor({ plugins: createPlateEditorPlugins() });
    const result = await docxFileToFragment(headlessEditor, file);
    const sanitized = sanitizePlateFragment(result.fragment);
    return sanitized.length ? sanitized : (EMPTY_EDITOR_VALUE as any[]);
}
